import type { AlignType } from '../types';

export const alignTypeToJustifyContent = (align?: AlignType) => {
  switch (align) {
    case 'center':
      return 'center';
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    default:
      return undefined;
  }
};
